export const getUrl = (
  href?: string,
  buttonSrc?: string,
  query?: Record<string, string | undefined>,
) => {
  if (href) {
    return href;
  }

  if (buttonSrc) {
    const url: URL = new URL(buttonSrc, process.env.NEXT_PUBLIC_BASE_SERVER_URL);

    if (!query) {
      return url.toString();
    }

    Object.entries(query).forEach(([key, value]) => value && url.searchParams.append(key, value));

    return url.toString();
  }

  return '';
};
